/**
 * Card — default surface primitive. Pass `interactive` for hover lift.
 */

import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  padding?: number | string;
  glass?: boolean;
  inset?: boolean;
}

const Card: React.FC<CardProps> = ({
  interactive,
  padding = 'var(--space-5)',
  glass,
  inset,
  className,
  style,
  children,
  ...rest
}) => {
  const base: React.CSSProperties = {
    background: inset
      ? 'var(--bg-surface-inv)'
      : glass
        ? 'var(--bg-surface-2)'
        : 'var(--bg-surface-1)',
    color: inset ? '#fff' : undefined,
    border: inset ? '1px solid rgba(255,255,255,0.08)' : '1px solid var(--border-1)',
    borderRadius: 'var(--radius-lg)',
    padding,
    boxShadow: 'var(--shadow-sm)',
    ...style,
  };

  return (
    <div
      className={[interactive ? 'cg-card--interactive' : '', className].filter(Boolean).join(' ') || undefined}
      style={base}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
